// Action Center (Sales Orders landing) pieces for Time & Materials orders (slice 1d).
import React from 'react';
import ErrorBoundary from '../ErrorBoundary.jsx';

/**
 * The "T&M: Ready to Price" section (categories.tm_ready_to_price). Row pieces (AcRow, AcPill) and
 * the money formatter are the page's own, passed in so the section looks like every other one.
 */
export function tmReadyToPriceSection({ AcRow, AcPill, fmtMoney }) {
  return {
    key: 'tm_ready_to_price', title: 'T&M: Ready to Price', icon: 'bi-calculator',
    accent: '#0aa2c0', blurb: 'Time & Materials orders waiting on Approve T&M Pricing',
    // Each row sits in its own boundary: a bad row shows a one-line message, not a blank page.
    render: (item, onSelect) => (
      <ErrorBoundary key={`tm-${item.sales_order_id}`} label={`The T&M row for ${item.order_number || 'this order'}`}>
      <AcRow item={item} onSelect={onSelect}
        chips={<>
          <AcPill tone={item.reason === 'Shipped: ready to price' ? 'info' : 'secondary'} icon="bi-calculator">
            {item.reason || 'T&M pending'}
          </AcPill>
          {item.tm_estimate_total != null && (
            <AcPill tone="light" title="Internal estimate (not a price)">{item.tm_estimate_label || 'est.'} {fmtMoney(item.tm_estimate_total)}</AcPill>
          )}
          {item.tm_not_to_exceed != null && (
            <AcPill tone="warning" title="Internal not-to-exceed">NTE {fmtMoney(item.tm_not_to_exceed)}</AcPill>
          )}
        </>}
        detail={
          <span className="text-body-secondary">
            {item.reason === 'Shipped: ready to price'
              ? 'Every piece that will ship has shipped: price it, then create the close-out invoice.'
              : 'Production is done: ship the good pieces, then price it.'}
          </span>
        }
      />
      </ErrorBoundary>
    ),
  };
}

/** One line under the KPI tiles: "T&M pending: N orders · est. $X" (no fifth tile). */
export function TmPendingSummaryLine({ summary, fmtMoney }) {
  const n = Number(summary && summary.tm_pending_count) || 0;
  if (n <= 0) return null;
  return (
    <div className="small text-body-secondary mb-3" data-testid="tm-pending-line">
      <i className="bi bi-calculator me-1"></i>
      T&amp;M pending: {n} order{n === 1 ? '' : 's'} · est. {fmtMoney(summary.tm_pending_est_value)}
    </div>
  );
}
